import Rating from "@mui/material/Rating";

type FilterRatingProps = {
  filterName: string;
  value: number;
  precision?: number;
  disabled?: boolean;
  onChange: (filterName: string, value: number | null) => void;
};

export default function FilterRating(props: Readonly<FilterRatingProps>) {
  const { filterName, precision, disabled, onChange, value } = props;

  return (
    <Rating
      name={filterName}
      precision={precision}
      disabled={disabled}
      value={value}
      onChange={(_event, newValue) => {
        onChange(filterName, newValue);
      }}
    />
  );
}
